export class FendiProvider {
  constructor() {
    this.PRIORITY = [
      FendiProvider.ECOMMERCE,
      FendiProvider.ENRICHMENT,
      FendiProvider.DATA_WAREHOUSE,
    ];

    this.MAP = {
      dwh: FendiProvider.DATA_WAREHOUSE,
      enrichment: FendiProvider.ENRICHMENT,
      ecommerce: FendiProvider.ECOMMERCE,
      f4Ecommerce: FendiProvider.F4_ECOMMERCE,
      f4Campaign: FendiProvider.F4_CAMPAIGN,
    };
  }

  getProviderName(name) {
    return this.MAP[name];
  }
}

FendiProvider.DATA_WAREHOUSE = 'dataWarehouse';
FendiProvider.ENRICHMENT = 'enrichment';
FendiProvider.ECOMMERCE = 'ecommerce';
FendiProvider.LOOKBOOK = 'lookbook';
FendiProvider.PUBLISHED_DATA = 'publishedData';
FendiProvider.F4_ECOMMERCE = 'f4Ecommerce';
FendiProvider.F4_CAMPAIGN = 'f4Campaign';
FendiProvider.UNKNOWN = 'unknown';



// WEBPACK FOOTER //
// ./src/app/core/external-provider/external-provider.js